import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Divider, Grid, Link } from '@mui/material';
import { DealType, DealSource, DealStage } from '../../../../utils/enums'
import { format } from 'date-fns';

const FullDetails = ({ data }) => {
    return (
        <Accordion elevation={0} sx={{ borderRadius: '4px', '&:before': { height: '0px' } }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ margin: 0 }}>

                <h4>Details</h4>

            </AccordionSummary>
            <AccordionDetails
                sx={{ marginTop: '-17px' }}>
                <Divider />
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Deal Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>

                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Deal Owner</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Deal Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.dealName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Account Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.accountName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Type</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.type ? DealType[data?.type].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Expected Revenue</Typography></Grid>
                            <Grid item xs={8}><Typography>$ {data?.expectedRevenue || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Lead Source</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.dealSource ? DealSource[data?.dealSource].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Contact Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.contactName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Modified By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.updatedAt ? format(new Date(data.updatedAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Country</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.country || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Amount</Typography></Grid>
                            <Grid item xs={8}><Typography>$ {data?.amount || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Closing Date</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.closingDate ? format(new Date(data.closingDate), 'MMMM do yyyy') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Stage</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.stage ? DealStage[data?.stage].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Probability (%)</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.probability || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Next Step</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.nextStep || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Campaign Source</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.campaignSource || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Created By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.createdAt ? format(new Date(data.createdAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>

                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Description Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Description</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.description || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default FullDetails;